module.exports = __webpack_public_path__ + "static/copper-dragon-wyrmling-e571ca07acdd1ff05344644bb9bfa15a.webp";